module.exports = __webpack_public_path__ + "media/ping_h5.a0278ab5.webm";